export default function () {
  const widgetName = 'bigCardsWidget';
  const widgetOpts = bigCardsWidgetOpts;

  function rebuildWidget(data) {
    const widgetItems = $(`#${widgetName} .card-widget-item`);
    const dataItems = data.items;
    widgetItems.each(function (index, item) {
      // create a div and add it to the card widget item. Use jQuery
      const shapes = $(
        '<div class="kaleidoscope"><div class="kaleidoscope__abstract"></div><div class="kaleidoscope__people"></div></div><div class="shape"></div>'
      );
      $(item).append(shapes);
      const link = $(item).find('.card-content');
      const url = dataItems[index].URL;
      // convert the link to a anchor tag
      if (url) {
        link.wrap('<a class="link link-' + 0 + index + '" href="' + url + '"></a>');
      }
      $(item).find('.buttonwrap').remove();
    });
  }
  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW',
    },
    cardWidgetLoaded: function (data) {
      rebuildWidget(data);
    },
    itemsPerPanel: 1,
    hasImages: false,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: [''], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 2,
    moreButton: {
      visible: false,
      text: 'MORE',
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: false,
    textOverImage: false,
  });
}
